import React from 'react';
import { Checkbox } from '@attentive-platform/stem-ui';

export const HighlightedText = ({ text, searchQuery }) => {
  if (!searchQuery || !searchQuery.trim()) {
    return <>{text}</>;
  }

  const query = searchQuery.toLowerCase().trim();
  const lowerText = text.toLowerCase();
  const index = lowerText.indexOf(query);

  if (index === -1) {
    return <>{text}</>;
  }

  const before = text.substring(0, index);
  const match = text.substring(index, index + query.length);
  const after = text.substring(index + query.length);

  return (
    <>
      {before}
      <mark className='rosetta-search-highlight'>{match}</mark>
      {after}
    </>
  );
};

export const ScopeItem = ({ scope, isSelected, onToggle, onClick, disabled, searchQuery }) => (
  <div className={`rosetta-scope-item ${isSelected ? 'selected' : ''}`} onClick={onClick}>
    <Checkbox checked={isSelected} onChange={onToggle} disabled={disabled} size='small' />
    <div className='rosetta-scope-name'>
      <HighlightedText text={scope.scope_name} searchQuery={searchQuery} />
    </div>
    {scope.is_default_selected && <div className='rosetta-included-tag'>INCLUDED</div>}
  </div>
);

export const ScopeCategory = ({
  title,
  scopes,
  tradeId,
  selectedScopes,
  onScopeItemClick,
  onToggleScope,
  searchQuery,
  onSelectAll,
  onDeselectAll
}) => {
  if (scopes.length === 0) return null;

  const handleSelectAll = e => {
    e.stopPropagation();
    onSelectAll(tradeId, scopes);
  };

  const handleDeselectAll = e => {
    e.stopPropagation();
    onDeselectAll(tradeId, scopes);
  };

  return (
    <div className='rosetta-scope-category'>
      <div className='rosetta-scope-category-header'>
        <h4 className='rosetta-scope-category-title'>{title}</h4>
        <div className='rosetta-scope-select-actions'>
          <button type='button' className='rosetta-select-link' onClick={handleSelectAll}>
            Select all
          </button>
          <span className='rosetta-select-divider'>/</span>
          <button type='button' className='rosetta-select-link' onClick={handleDeselectAll}>
            Deselect all
          </button>
        </div>
      </div>

      {scopes.map(scope => (
        <ScopeItem
          key={scope.scope_id}
          scope={scope}
          isSelected={selectedScopes?.has(scope.scope_id) || false}
          onToggle={() => !scope.is_default_selected && onToggleScope(tradeId, scope.scope_id)}
          onClick={() => onScopeItemClick(scope)}
          disabled={scope.is_default_selected}
          searchQuery={searchQuery}
        />
      ))}
    </div>
  );
};

export const CustomRequirement = ({ trade, customScope, onChange }) => (
  <div className='rosetta-custom-scope-item mt-2'>
    <label htmlFor={`custom-${trade.trade_id}`}>{trade.trade_name} - Additional Requirements</label>
    <textarea
      id={`custom-${trade.trade_id}`}
      placeholder='Enter any specific requirements, exclusions, or clarifications...'
      value={customScope}
      onChange={onChange}
    />
  </div>
);
